import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'

import './CurtainsScene.scss'

export default class CurtainsScene extends Component {

  render () {
    const { bg, text1, text2, visible } = this.props
    return (
      <CSSTransitionGroup
        transitionName='co_curtains'
        transitionEnterTimeout={2500}
        transitionLeaveTimeout={1450}
      >
        {visible &&
          <div className='co_curtains'>
            <div className='co_curtains__door-wrap co_curtains__door-wrap--left'>
              <div
                className='co_curtains__door-left'
                style={{ backgroundImage: `url(${bg})` }} />
            </div>
            <div className='co_curtains__door-wrap co_curtains__door-wrap--right'>
              <div
                className='co_curtains__door-right'
                style={{ backgroundImage: `url(${bg})` }} />
            </div>

            <div id='co_curtains__bg' className='co_curtains__bg' style={{ backgroundImage: `url(${bg})` }} />

            <div className='co_curtains__content'>
              <div id='co_curtains__text1' className='co_curtains__text co_curtains__text--1'>
                {text1}
              </div>
              <div id='co_curtains__text2' className='co_curtains__text co_curtains__text--2'>
                {text2}
              </div>
            </div>
          </div>
        }
      </CSSTransitionGroup>
    )
  }

  static propTypes = {
    bg: PropTypes.string,
    text1: PropTypes.string,
    text2: PropTypes.string,
    visible: PropTypes.bool
  }
}



// WEBPACK FOOTER //
// ./src/templates/coffee/components/curtains/CurtainsScene.js